// extracted by mini-css-extract-plugin
export default {"video":"VideoViewer_video__FW0-4","error":"VideoViewer_error__vFALh"};